/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
  /*
  const accordionTriggers = Array.from(document.getElementsByClassName('mobile-menu__accordion-trigger'))
  accordionTriggers.forEach((trigger) => {
    trigger.addEventListener('click', () => {
      const accordions = Array.from(document.getElementsByClassName('mobile-menu__accordion'))
      accordions.forEach((a)=>a.classList.remove('open'))
      const accordion = trigger.parentNode;
      accordion.classList.toggle('open')
    })
  }) */

   const faqs = document.querySelectorAll(".widget__link");

    faqs.forEach(button => {
        button.addEventListener("click", () => {
            // Remove the 'active' class from all buttons
          setTimeout(function(){
            faqs.forEach(btn => btn.classList.remove("is-selected"));
            // Add the 'active' class to the clicked button
            button.classList.add("is-selected");
            },500)
        });
    });

  const buttons = document.querySelectorAll('.mobile-menu__accordion-trigger');

    buttons.forEach(button => {
        button.addEventListener('click', () => {
            const parentDiv = button.parentElement;
            
            // Check if the parent div is already open
            const isOpen = parentDiv.classList.contains('open');
            
            // Remove "open" class from all parents
            document.querySelectorAll('.mobile-menu__accordion').forEach(div => div.classList.remove('open'));

            // Toggle "open" class for the clicked button's parent
            if (!isOpen) {
                parentDiv.classList.add('open');
            }
        });
    });

  var groupedLists = {};

    // Get all DIVs with the class 'list-group'
    var listGroups = document.querySelectorAll('.fodmap-group');

    listGroups.forEach(function(div) {
        var parentId = div.getAttribute('data-id');
console.log(parentId)
        // If the ID already exists in the groupedLists, append the list items to the existing group
        if (groupedLists[parentId]) {
            var listItems = div.querySelectorAll('.accordion__content');
            listItems.forEach(function(li) {
                groupedLists[parentId].appendChild(li);
            });
            div.remove(); // Remove the current DIV after appending its list items
        } else {
            // If the ID doesn't exist, create a new entry in the groupedLists
            groupedLists[parentId] = div.querySelector('.accordion__content');
        }
    });
  


  document.addEventListener("DOMContentLoaded", () => {
    setTimeout(function(){
      const button = document.querySelector('.rc-subscription-details__button');
        if(!button) return
        const svg = button.querySelector('svg');
          if (svg) {
            svg.remove();
        }
    const strongElement = document.createElement('strong');
        strongElement.textContent = '?';

    const span = button.querySelector('span');
        button.insertBefore(strongElement, span);
    },1000);
  setTimeout(function(){
    const div = document.querySelector('.onetime-radio .rc-radio__label');

        // Extract the text content
        const textContent = div.textContent;

        // Regex to capture the text and price
        const regex = /(.+)\s\$(\d+\.\d+)/;

        // Execute the regex on the text content
        const match = textContent.match(regex);

        if (match) {
            const extractedText = match[1];  // The first capturing group
            const extractedPrice = match[2]; // The second capturing group

            // Create span elements for the text and price
            const textSpan = document.createElement('span');
            const priceSpan = document.createElement('span');

            // Set the text content of the spans
            textSpan.textContent = extractedText;
            priceSpan.textContent = `$${extractedPrice}`;

            // Clear the original div content
            div.textContent = '';

            // Append the spans to the div
            div.appendChild(textSpan);
            div.appendChild(priceSpan);
        } else {
            console.log("No match found");
        }
  },1000);
    
  function populateEmptyYotpoWithReviews(){
    const yotpoElems = Array.from(document.querySelectorAll('.yotpo.bottomLine .yotpo-display-wrapper'));
    yotpoElems.forEach((elem)=>{
      const wrapper = elem.querySelector('.standalone-bottomline')
      if(!wrapper){
        elem.innerHTML = `
 <div class="standalone-bottomline" data-source="default" tabindex="-1">
            <div class="yotpo-bottomline pull-left star-clickable" tabindex="0">
                <span class="yotpo-stars">
                    <span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span
                    ><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span
                    ><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span
                    ><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span
                    ><span class="yotpo-icon yotpo-icon-empty-star rating-star pull-left"></span
                    ><span class="sr-only">0 star rating</span>
                </span>
                <a href="javascript:void(0)" class="text-m" aria-label="2 reviews" tabindex="-1">0 Reviews</a>
                <div class="yotpo-clr"></div>
            </div>
            <div class="yotpo-clr"></div>
        </div>        `
      }
    })
    
  }

  setTimeout(populateEmptyYotpoWithReviews, 2000);
});
  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
